module.exports = kolibriCoreAppGlobal.coreVue.mixins.responsiveWindowMixin;